(function() {

	angular
		.module('ngmvac')
		.service('groupedProperties', GroupedPropertiesService);

	function GroupedPropertiesService() {

		return {
			getGroupedProperty: getGroupedProperty
		}

		function getGroupedProperty(data, criteriaProperties, returnProperties, flag) {
			var groups = [];

			if( angular.isArray(criteriaProperties) && angular.isArray(returnProperties) ) {
				angular.forEach(data, function(item) {
					var insert = true;
					angular.forEach( groups, function(group, indexGroup) {
						angular.forEach( criteriaProperties, function(property, indexProperty) {
							if( group[property] == item[property] ) {
								insert = false;
							}
						});
					});

					if( insert ) {
						var auxObj = {};
						angular.forEach( returnProperties, function(property, indexProperty) {
							auxObj[property] = item[property];
						});
						if( flag ) {
							auxObj.checked = false;
						}
						groups.push(auxObj);
					}
				});
			}

			return groups;
		}

	}

})();